import "./pdfLoader.css";
import { format, compareAsc } from "date-fns";
import documentImg from "../dokument.png";
import { useEffect, useRef } from "react";
import LoznicaLogo from "./loznica.jpg";

const PDFLoader = ({
  itemList,
  commentsActive,
  linksActive,
  documentsActive,
  imagesActive,
  account,
  location,
  loggedUser,
  numberOfCopy,
  categoriesItem,
  setCurrentItem,
}) => {

  console.log(account)
  const handleNumberOfcomment = () => {
    let numberCom = 0;
    itemList.map((item) => {
      if (item.comments.length !== 0) {
        numberCom += item.comments.length;
      }
    });
    console.log(numberCom);
    return numberCom;
  };

  const downloadDocument = (doc) => {
    console.log(doc);
    const a = document.createElement("a");
    a.href = doc.data;
    a.download = doc.name;
    a.click();
  };

  const handleScroll = () => {
    console.log("Scroling");
  };

  const getSelectedCategories = () => {
    const selectedCategories = [];
    for (const item of itemList) {
      for (const category of item.categories) {
        if (category.selected && !selectedCategories.find(selectedCategory => selectedCategory.id === category.id)) {
          selectedCategories.push(category);
        }
      }
    }
    return selectedCategories;
  };

  return (
    <main className="pdf-loader" onScroll={handleScroll}>
      <div className="pdf-header1">
        <table className="tg" style={{ tableLayout: "fixed", width: "100%" }}>
          <thead>
            <tr>
              <td className="pdf-logo" rowSpan="3">
                <img src={LoznicaLogo} alt="Logo" />
              </td>
              <td className="pdf-upper">KOMPANIJA</td>
              <td className="pdf-upper">LOKACIJA</td>
              <td className="pdf-upper">DATUM</td>
              <td className="pdf-upper">PERIOD</td>
            </tr>
            <tr>
              <td className="pdf-lower">{account?.company_name}</td>
              <td className="pdf-lower">{location?.location_name}</td>
              <td className="pdf-lower">
                {itemList.length !== 0 &&
                  format(itemList[0].timeCreated, "dd.MM.yyyy")}
              </td>
              <td className="pdf-lower">
                {itemList.length !== 0 &&
                  (compareAsc(
                    new Date(
                      new Date(itemList[0].timeCreated).setHours(0, 0, 0, 0)
                    ),
                    new Date(
                      new Date(
                        itemList[itemList.length - 1].timeCreated
                      ).setHours(0, 0, 0, 0)
                    )
                  ) !== 0
                    ? format(
                        itemList[itemList.length - 1].timeCreated,
                        "dd.MM.yyyy"
                      )
                    : "")}
              </td>
            </tr>
            <tr>
              <td className="pdf-title" colSpan="4">
                IZVEŠTAJ - {format(new Date(), "dd.MM.yyyy")}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="pdf-upper">KATEGORIJE</td>
              <td className="pdf-upper">BROJ STAVKI I KOMENTARA</td>
              <td className="pdf-upper">KREATOR</td>
              <td className="pdf-upper">VREME</td>
              <td className="pdf-upper">BROJ KOPIJE</td>
            </tr>
            <tr>
              <td className="pdf-lower">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {getSelectedCategories().map(category => (
                    <div
                      key={category.id}
                      style={{
                        color: category.letter_color,
                        backgroundColor: category.color,
                        padding: "2px 4px",
                        border: "1px solid black"
                      }}
                    >
                      {category.letter}
                    </div>
                  ))}
                </div>
              </td>
              <td className="pdf-lower">
                <span>{itemList.length}</span>
                <br />
                <span>{handleNumberOfcomment()}</span>
              </td>
              <td className="pdf-lower">{loggedUser?.name || loggedUser?.user_email}</td>
              <td className="pdf-lower">{format(new Date(), "hh:mm")}</td>
              <td className="pdf-lower">{numberOfCopy !== undefined && numberOfCopy}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="pdf-items">
        {itemList?.map((item, index) => {
          return (
            <article className="pdf-item" key={item.id}>
              <div className="pdf-item-header">
                <div className="pdf-item-header-left" style={{ fontWeight: "bold" }}>
                  {index + 1}.
                </div>
                <div className="pdf-item-header-left empty">
                  {item.categories.filter(category => category.selected).map((category, index) => {
                    const styles = {
                      color: category.letter_color,
                      backgroundColor: category.color,
                    };
                    return (
                      <div
                        style={{
                          ...styles,
                          height: `${100 / item.categories.filter(category => category.selected).length}%`
                        }}
                        className="pdf-item-category"
                        key={index}
                      >
                        {category.letter}
                      </div>
                    );
                  })}
                </div>
                <div className="pdf-item-header-middle">{item.title}</div>
                <div className="pdf-item-header-right">
                  <div className="pdf-item-header-data" style={{ fontSize: "10px", wordBreak: "break-word" }}>
                    {((item.name || item.email || loggedUser?.user_email) || '').length > 25
                      ? `${((item.name || item.email || loggedUser?.user_email) || '').slice(0, 25)}...`
                      : (item.name || item.email || loggedUser?.user_email)}
                  </div>
                  <div className="pdf-item-header-data">
                    {format(item.timeCreated, "HH:mm dd.MM.yyyy")}
                  </div>
                  <div className="pdf-item-header-data">
                    {item.comments.length}
                  </div>
                </div>
              </div>
              {item.data.map((field) => {
                const { id, data, name } = field;
                return (
                  <div className="pdf-item-data" key={id}>
                    <span className="pdf-item-data-title">{name}</span>
                    <span className="pdf-item-data-content">{data}</span>
                  </div>
                );
              })}
              {imagesActive &&
                item.images.length !== 0 &&
                item.images[0].data !== "" && (
                  <>
                    <span className="pdf-item-data-title">Fotografije</span>
                    <div className="pdf-item-images">
                      {item.images.map((image, index) => (
                        <img src={image.data} alt="" key={index} />
                      ))}
                    </div>
                  </>
                )}
              {documentsActive && item.documents.length > 0 && (
                <>
                  <span className="pdf-item-data-title">Dokumenta</span>
                  {item.documents.map((document, index) => {
                    return (
                      <div
                        className="pdf-item-document"
                        key={index}
                        onClick={() => downloadDocument(document)}
                      >
                        <img src={documentImg} alt="" />
                        <span>{document.name}</span>
                      </div>
                    );
                  })}
                </>
              )}
              {linksActive && item.links.length > 0 && (
                <>
                  <span className="pdf-item-data-title">Linkovi</span>
                  {item.links.map((link) => {
                    return (
                      <span className="pdf-item-data-content" key={link.link_id}>
                        {link.link}
                      </span>
                    );
                  })}
                </>
              )}
              {commentsActive && item.comments.length > 0 && (
                <>
                  <span className="pdf-item-data-title">Komentari</span>
                  {item.comments.map((comment, index) => {
                    return (
                      <article className="pdf-item-comment" key={index}>
                        <div className="pdf-item-comment-header">
                          <span className="pdf-item-data-content">
                            {index + 1}.
                          </span>
                          <span className="pdf-item-data-content">
                            {comment.user}
                          </span>
                          <span className="pdf-item-data-content">
                            {comment.timeCreated}
                          </span>
                        </div>
                        {comment.text !== "" && (
                          <span className="pdf-item-data-content">
                            {comment.text}
                          </span>
                        )}
                        {comment.image.length !== 0 && comment.image !== "" && (
                          <>
                            <span className="pdf-item-data-title">Image</span>
                            <img src={comment.image.data} alt="" />
                          </>
                        )}
                        {comment.document.length !== 0 && (
                          <>
                            <span className="pdf-item-data-title">Document</span>
                            <div
                              className="pdf-item-document"
                              key={index}
                              onClick={() =>
                                downloadDocument(comment.document[0])
                              }
                            >
                              <img src={documentImg} alt="" />
                              <span>{comment.document[0].name}</span>
                            </div>
                          </>
                        )}
                        {comment.link !== "" && (
                          <>
                            <span className="pdf-item-data-title">Link</span>
                            <span className="pdf-item-data-content">
                              {comment.link}
                            </span>
                          </>
                        )}
                      </article>
                    );
                  })}
                </>
              )}
            </article>
          );
        })}
      </div>
    </main>
  );
};

export default PDFLoader;